export default "__VITE_ASSET__BN9UcJ5n__"